<template>
    <div class="message-bubble" :class="{my: isMy, group: isGroupClass, grouped: !first}">
        <div class="message-bubble-body__profile" v-if="showProfile" @click="showProfileCard">
            <img :src="img" v-if="img">
            <div class="initials" :style="{background: color}">
                <span>{{ initials }}</span>
            </div>
        </div>
        <div class="message-bubble-body" :class="messageBubbleBodyClassObject">

            <div class="message-bubble-body__resend-button" v-if="message.isError()" @click="resend">
                <resend></resend>
            </div>

            <div class="message-bubble-body__container">

                <div v-if="(!isMy && !isContactsAttachemnts) || showTitle" @click="showProfileCard" class="message-bubble-body__name message-bubble-body__name-clikable">
                    <span>{{ title }}</span>
                </div>

                <div class="message-bubble-body__text-container">
                    <attachments v-if="hasAttachments" @sendContacts="$emit('sendContacts')" :attachments="attachments" :isMy="isMy"></attachments>
                    <div v-if="message.showText()" class="message-bubble-body__text" v-html="preparedMessage"></div>
                    <div class="message-bubble-body__time">
                        <span v-if="time">{{ time }}</span>
                        <clocks v-else-if="message.isSending()"></clocks>
                        <delivery-error v-else-if="message.isError()"></delivery-error>
                    </div>
                </div>

            </div>
            <div class="message-bubble-body__resend-text" v-if="message.isError()">
                <span> {{ $t("common.notSent") }} </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Message from "../../models/Messages/Message";
    import Clocks from "../svg/Clocks";
    import DeliveryError from "../svg/DeliveryError";
    import Resend from "../svg/Resend";
    import ChatTypes from "../../enums/ChatTypes";
    import Attachments from "./atachments/Attachments";
    import { process } from '../../../../common/MessageProcessor';
    import {EventBus} from "@common/EventBus";
    import AttachmentsTypes from "../../enums/AttachmentsTypes";
    import { parseJson } from '@common/TypesHelper';
    import MeetingAttachmentBottom from "@share/chat/components/chat/atachments/meeting/MeetingAttachmentBottom";

    export default Vue.extend({
        name: "Message",
        components: {MeetingAttachmentBottom, Resend, DeliveryError, Clocks, Attachments},
        props: {
            message: {
                type: Message,
                required: true
            },
            first: {
                type: Boolean
            },
            last: {
                type: Boolean
            }
        },
        computed: {
            time() {
                return (this.message && !this.message.status && this.message.createdAt)
                    ? this.message.createdAt.toFormat('HH:mm')
                    : '';
            },
            isMy() {
                return this.message.userID == this.$store.state.session.userId;
            },
            preparedMessage() {
                const result = this.message.message || '';
                return process(result, ['img', 'a'], true);
            },
            room() {
                return this.$store.state.chat.room.instance;
            },
            isGroup() {
                return this.room && (this.room.type != ChatTypes.direct || this.room.membersCount > 2);
            },
            isGroupClass() {
              return this.isGroup && !this.isMy;
            },
            showTitle() {
                return this.isGroup && this.first && !this.isMy;
            },
            showProfile() {
                return this.isGroupClass && this.last;
            },
            user() {
                return this.$store.state.chat.profiles.list[this.message.userID] || null;
            },
            title() {
                return this.user ? this.user.fullName() : '';
            },
            img() {
                return this.user && this.user.photoUrl(this.$store.state.session);
            },
            color() {
                return this.user ? this.user.color() : this.room.color();
            },
            initials() {
                return this.user ? this.user.initials() : '';
            },
            attachments() {
                return parseJson(this.message.attachments);
            },
            hasAttachments() {
                return this.attachments?.length;
            },
            isContactsAttachemnts() {
                return this.attachments?.filter(item => item.type == AttachmentsTypes.contacts)?.length;
            },
            messageBubbleBodyClassObject() {
                return {
                    "message-bubble-body_bordered": this.attachments,
                    "message-bubble-body_is-error": this.message.isError(),
                    "message-bubble-body_is-mine": this.isMy
                }
            },
            showMeetingBottom() {
                return this.message.hasMeetingAttachment();
            }
        },
        methods: {
            resend() {
                this.$emit('resend', this.message);
            },
            showProfileCard() {
                EventBus.$emit('showChatByUserId', this.message.userID);
            }
        },
        mounted() {

        }
    });
</script>
